import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomePage from './components/HomePage.vue';
import LeaveOurMark from './components/LeaveOurMark.vue';

// Define routes
const routes: RouteRecordRaw[] = [
	{
		path: '/',
		component: HomePage,
	},
	{
		path: '/releases',
		component: HomePage,
		props: { showLinks: true },
	},
	{
		path: '/leave-our-mark',
		component: LeaveOurMark
	}
];

// Create the router
const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router;